import React from "react";
import PropTypes from "prop-types";
import "./ToggleButton.scss";

function ToggleButton(props) {
  return (

    <label className="switch">
      <input
        type="checkbox"
        id="toggle-button"
        checked={props.isChecked}
        aria-label="Toggle option"
        onChange={props.onChange}
        disabled={props.isdisable}
      />
      <span className="slider round"></span>
    </label>

  );
}

ToggleButton.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ToggleButton;
